import qs from 'qs';
import { FilterOptions } from '~/components/Map/panels/GeocollectDatatablePanel/components/CollectItemFilterPopup/CollectItemFilterPopup';

/**
 * Convert FilterOptions from UI to Strapi filters format
 * Based on Strapi filters documentation: https://docs.strapi.io/dev-docs/api/rest/filters
 */
export const convertFiltersToStrapiQuery = (filterOptions: FilterOptions): any => {
  const filters: any = {};

  // Text search - search in properties.name field (Strapi nested approach)
  if (filterOptions.searchText && filterOptions.searchText.trim() !== '') {
    const searchText = filterOptions.searchText.trim();

    // Search in properties.name using Strapi nested object syntax
    filters.properties = {
      name: {
        $containsi: searchText,
      },
    };
  }

  // Date range filter (created_at)
  if (filterOptions.dateRange && filterOptions.dateRange.length === 2) {
    const [startDate, endDate] = filterOptions.dateRange;
    filters.created_at = {
      $gte: startDate,
      $lte: endDate,
    };
  }

  // Sync date range filter (sync_at)
  if (filterOptions.syncDateRange && filterOptions.syncDateRange.length === 2) {
    const [startDate, endDate] = filterOptions.syncDateRange;
    filters.sync_at = {
      $gte: startDate,
      $lte: endDate,
    };
  }

  // Creator IDs filter (user relation)
  if (filterOptions.creatorIds && filterOptions.creatorIds.length > 0) {
    filters.user = {
      id: {
        $in: filterOptions.creatorIds,
      }
    };
  }

  // Dynamic form fields (properties JSON field) - temporarily disabled
  // TODO: Implement proper JSONB field-specific search later
  if (filterOptions.selectedFields) {
    for (const [fieldKey, fieldValue] of Object.entries(filterOptions.selectedFields)) {
      if (fieldValue && fieldValue.trim() !== '') {
        // For now, just add to general properties search
        // Later: implement specific JSON path queries like properties->>'fieldKey'
        if (!filters.properties) {
          filters.properties = {};
        }
        // Combine with existing properties filter using $and
        if (filters.properties.$containsi) {
          filters.$and = [
            { properties: { $containsi: filters.properties.$containsi } },
            { properties: { $containsi: `"${fieldKey}":"${fieldValue}"` } }
          ];
          delete filters.properties;
        } else {
          filters.properties.$containsi = `"${fieldKey}":"${fieldValue}"`;
        }
      }
    }
  }

  return filters;
};

/**
 * Convert FilterOptions to complete query string for Strapi API
 */
export const buildStrapiQueryString = (
  filterOptions: FilterOptions,
  pagination?: { page: number; pageSize: number },
  populate?: string[]
): string => {
  const queryObject: any = {};

  // Add filters
  const filters = convertFiltersToStrapiQuery(filterOptions);
  if (Object.keys(filters).length > 0) {
    queryObject.filters = filters;
  }

  // Add pagination
  if (pagination) {
    queryObject.pagination = {
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
  }

  // Add populate
  if (populate && populate.length > 0) {
    queryObject.populate = populate;
  }

  return qs.stringify(queryObject, {
    encodeValuesOnly: true, // prettify URL
  });
};